import * as signals from "signals";

const newSignal = () => new signals.Signal();

export default {
  realityCheck: newSignal(),
  gameStarted: newSignal(),
  gameInited: newSignal(),
  orientationChanged: newSignal(),
  loadAssets: newSignal(),
  loadingProgress: newSignal(),
  textAssetsLoadingComplete: newSignal(),
  preloaderAssetsLoadingComplete: newSignal(),
  mainGameAssetsLoadingComplete: newSignal(),
  continueBtnClick: newSignal(),
  muteAll: newSignal(),
  errorMessage: newSignal(),
  makeBet: newSignal(),
  isMobileDevice: newSignal(),

  playerWin: newSignal(),
  playerConnect: new signals.Signal(),

  currentBetHasChanged: newSignal(),
  currentAutoCollectHasChanged: newSignal(),

  stateChanged: newSignal(),

  //SERVER SIGNALS
  serverMessage: newSignal(),
  backendMessage: newSignal(),
  gameMessage: newSignal(),
  getGameInit: newSignal(),

  autoBetButtonClicked: newSignal(),

  startPlane: newSignal(),

  initGame: newSignal(),
  socketClosed: newSignal(),
  socketOpened: newSignal(),
  getGameSpin: newSignal(),
  spinResponse: newSignal(),
  sessionTimeout: newSignal(),
  errorConnection: newSignal(),
  setBetStatus: newSignal(),
  playersStateChanged: newSignal(),
  setMakeBet: newSignal(),
  multipliersHistory: newSignal(),
  playerTakeWin: newSignal(),
  betsUpdates: newSignal(),
  resetBets: newSignal(),

  tick: newSignal(),
  tickerStart: newSignal(),
  tickerStop: newSignal(),
  startFly: newSignal(),
  stopFly: newSignal(),

  forceIdle: newSignal(),
  forceRoundStart: newSignal(),
  forceRoundEnd: newSignal(),
  forceMakeBets: newSignal(),
  autoCollectHappened: newSignal(),

  makeBets: newSignal(),
  roundStart: newSignal(),
  roundEnd: newSignal(),

  multiplier: newSignal(),

  urlSettings: newSignal(),

  //MODEL SIGNALS
  notEnoughMoney: newSignal(),
  graphicsCreated: newSignal(),
  modelInitStored: newSignal(),
  balanceUpdate: newSignal(),
  setWin: newSignal(),
  onWin: newSignal(),

  //Feature
  startFeature: newSignal(),
  stopFeature: newSignal(),
  showfreebets: newSignal(),
  featureServerHappened: newSignal(),

  //UI Signals
  UIisReady: newSignal(),
  initUI: newSignal(),
  spinBtnPressed: newSignal(),

  requestFullScreen: newSignal(),

  musicClick: newSignal(),
  soundClick: newSignal(),
  muteClick: newSignal(),

  chatVisibilityChange: newSignal(),

  enableGamePopups: new signals.Signal(),
  disableGamePopups: new signals.Signal(),
  
  onClose: newSignal(),
  preAuth: newSignal(),

  terminateWSClient: newSignal()
};
